import { Avatar, Badge, Tag } from "antd";
import React from "react";

const data = [
  {
    title: "Natali Craig",
    online: true,
    notification: "2",
  },
  {
    title: "Drew Cano",
    notification: "2",
  },
  {
    title: "Natali Craig",
  },
  {
    title: "Natali Craig",
    online: true,
    notification: "1",
  },
  {
    title: "Natali Craig",
  },
  {
    title: "Natali Craig",
    online: true,
    notification: "7",
  },
];

function Contacts() {
  return (
    <div
      className="calendar_Style p-5 rounded-2xl"
      style={{
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 18px 0px #4B465C1A",
      }}
    >
      <h1 className="font-semibold text-lg mb-3">Contacts</h1>
      <div className="max-h-[150px] overflow-y-scroll pr-[20px]">
        {data.map((items, i) => {
          const FirstName = items.title.charAt(0);
          return (
            <div
              key={i}
              className="flex justify-between items-center my-5 duration-100"
              style={{
                border: "1.5px solid #FFFFFF",
              }}
            >
              <div className="flex gap-3 items-center">
                <Avatar size={"large"} src={""} alt="profile">
                  {FirstName}
                </Avatar>
                <div>
                  <h1 className="font-semibold text-lg">{items.title}</h1>
                  <div className="flex gap-2">
                    <Badge dot color={items.online ? "green" : "gray"} />
                    <p>{items.online ? "Online" : "30 Minutes ago"}</p>
                  </div>
                </div>
              </div>
              <div className="flex justify-between flex-col items-end gap-2">
                <p>10:45</p>
                {items.notification && (
                  <Tag
                    className="m-0 bg-orange1 text-white font-bold"
                    // color="magenta"
                  >
                    {items.notification}
                  </Tag>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Contacts;
